export default __webpack_public_path__ + "static/media/user5.45447052.jpg";